import {ImgText as ImgTextModel} from '../../models/editor/imgText'

interface ImgTextProps {
  img: ImgTextModel
}

export default function ImgText({img}: ImgTextProps) {
  return <div dangerouslySetInnerHTML={{__html: img.text as string}}></div>
}
